export default "__VITE_ASSET__CdpGH9E0__"